import axios from "axios";
import { removeToken } from "../utils/token";
import { store } from "../store/store";
import { logout } from "../store/slices/userSlice";
import { setGeneralAlertMessage } from "../store/slices/generalSlice";

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  timeout: 60000,
  headers: { "Content-Type": "application/json" },
  withCredentials: true,
});

api.interceptors.request.use(
  (config) => {
    const token = store.getState().auth.token;
    if (token && config.headers) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

api.interceptors.response.use(
  (response) => response.data,
  (error) => {
    if (error.response) {
      const { status } = error.response;

      if (status === 401) {
        store.dispatch(logout());
        store.dispatch(setGeneralAlertMessage({ type: "error", message: "Session timed out!" }));
        removeToken();
        window.location.href = "/";
      } else if (status === 500) {
        store.dispatch(setGeneralAlertMessage({ type: "error", message: "Server error. Please try again later." }));
      }
    } else if (error.message === "Network Error") {
      store.dispatch(
        setGeneralAlertMessage({
          type: "error",
          message: "No internet connection. Please check your connection and try again.",
        })
      );
    }

    return Promise.reject(error.response.data);
  }
);

export default api;
